import { ProvenanceBlock } from "../ProvenanceBlock";

export const ReportHeader = ({ model, t }) => (
  <header className="border-b-2 border-slate-900 pb-4" data-testid="dd-header">
    <div className="flex flex-wrap items-start justify-between gap-3">
      <div>
        <div className="font-heading text-lg font-bold tracking-tight text-slate-900">PlanGmina</div>
        <div className="text-[10px] uppercase tracking-widest text-slate-500">{t("dd.subtitle")}</div>
      </div>
      <div className="text-right text-xs text-slate-600">
        <div>{t("dd.refId")}: <b>{model.meta.ref_id}</b></div>
        <div>{t("dd.generatedAt")}: {(model.meta.generated_at || "").slice(0, 16).replace("T", " ")} UTC</div>
        <div>{t("dd.reportVersion")}: v{model.meta.report_version} · model {model.model_version}</div>
      </div>
    </div>
    <h1 className="mt-3 font-heading text-2xl font-bold text-slate-900" data-testid="dd-title">
      {t("dd.title")} — {t("dd.parcel")} {model.identity.number}
    </h1>
  </header>
);

export const ProvenanceSection = ({ model, t }) => (
  <div className="space-y-2" data-testid="dd-provenance-list">
    {(model.provenance || []).map((p) => (
      <ProvenanceBlock key={p.key} p={p} t={t} testId={`dd-prov-${p.key}`} />
    ))}
  </div>
);

export const AppendixSection = ({ model, t }) => (
  <div className="space-y-4">
    <div className="overflow-x-auto">
      <table className="w-full border-collapse text-xs" data-testid="dd-evidence-table">
        <thead>
          <tr className="bg-slate-900 text-left text-white">
            <th className="px-2 py-1.5">{t("dd.evidence.fact")}</th>
            <th className="px-2 py-1.5">{t("dd.evidence.value")}</th>
            <th className="px-2 py-1.5">{t("report.source")}</th>
            <th className="px-2 py-1.5">{t("dd.evidence.asOf")}</th>
          </tr>
        </thead>
        <tbody>
          {(model.evidence || []).map((e, i) => (
            <tr key={i} className="border-b align-top" data-testid={`dd-evidence-row-${i}`}>
              <td className="px-2 py-1.5">{e.fact_pl || e.fact}</td>
              <td className="px-2 py-1.5">{e.value_pl || e.value}</td>
              <td className="px-2 py-1.5">{e.source_authority || "—"}</td>
              <td className="px-2 py-1.5">{e.effective_date || "—"}</td>
            </tr>
          ))}
          {!(model.evidence || []).length && (
            <tr><td colSpan="4" className="px-2 py-2 text-slate-500">—</td></tr>
          )}
        </tbody>
      </table>
    </div>
    <div>
      <h3 className="mb-2 text-[11px] font-bold uppercase tracking-wider text-slate-500">{t("dd.sourcesFull")}</h3>
      <div className="space-y-2" data-testid="dd-sources-list">
        {(model.source_urls || []).map((s, i) => (
          <details key={i} className="rounded-lg border border-slate-200 bg-slate-50 p-3 text-xs" data-testid={`dd-source-${i}`}>
            <summary className="cursor-pointer font-medium text-slate-800">
              {s.authority || "—"} · {t("real.retrieved")}: {(s.retrieved_at || "").slice(0, 19).replace("T", " ")}
            </summary>
            <p className="mt-2 break-all font-mono-data text-[10px] text-slate-500">{s.url}</p>
          </details>
        ))}
      </div>
    </div>
  </div>
);

export const IntegrityBlock = ({ model, t }) => (
  <section className="mt-8 rounded-lg border-2 border-slate-900 p-4" data-testid="dd-integrity">
    <h2 className="font-heading text-sm font-bold uppercase tracking-widest text-slate-500">{t("dd.integrity")}</h2>
    <div className="mt-2 space-y-1 text-xs text-slate-700">
      <div>{t("dd.refId")}: <b>{model.integrity.ref_id}</b></div>
      <div>{t("dd.generatedAt")}: {model.integrity.generated_at}</div>
      <div>{t("dd.dataAsOf")}: {model.integrity.data_as_of || "—"}</div>
      <div>{t("dd.reportVersion")}: v{model.integrity.report_version} · model {model.integrity.model_version}</div>
      <div className="break-all font-mono-data text-[10px]">SHA-256: {model.integrity.report_hash}</div>
    </div>
    <p className="mt-3 text-[10px] leading-relaxed text-slate-500">{model.integrity.disclaimer_pl}</p>
  </section>
);
